import * as React from 'react';
import { useTranslation } from 'react-i18next';
import BaseDialog from 'common/components/base-dialog';
import { Box, Typography, Button } from '@mui/material';

interface CampaignModalDeleteProps {
    open: boolean;
    campaignName: string;
    handleClose: () => void;
    handleDelete: () => void;
}

const CampaignModalDelete: React.FC<CampaignModalDeleteProps> = ({
    open,
    campaignName,
    handleClose,
    handleDelete,
}) => {
    const { t } = useTranslation();
    return (
        <BaseDialog
            open={open}
            title={t('page.campaign.modal.delete.title')}
            fullWidth={false}
            maxWidth={false}
            sxContent={{
                width: '978px',
                padding: '50px 80px',
            }}
            onClose={handleClose}
        >
            <Box mt={'12px'}>
                <Typography
                    sx={{
                        fontSize: '22px',
                        lineHeight: '27px',
                        textAlign: 'center',
                        color: 'rgba(0, 0, 0, 1)',
                    }}
                >
                    <Typography
                        component="span"
                        sx={{
                            fontSize: '22px',
                            lineHeight: '27px',
                        }}
                    >
                        {t('page.campaign.modal.delete.question_prefix')} &quot;
                    </Typography>
                    <Typography
                        component="strong"
                        fontWeight="bold"
                        sx={{
                            fontSize: '22px',
                            lineHeight: '27px',
                        }}
                    >
                        {campaignName}
                    </Typography>
                    &quot; {t('page.campaign.modal.delete.question_suffix')}
                    <br />
                    <Typography
                        component={'span'}
                        sx={{
                            fontWeight: 'bold',
                            fontSize: '22px',
                            lineHeight: '27px',
                        }}
                    >
                        {t('page.campaign.modal.delete.caution')}{' '}
                    </Typography>
                    <Typography
                        component={'span'}
                        sx={{
                            fontSize: '22px',
                            lineHeight: '27px',
                        }}
                    >
                        {t('page.campaign.modal.delete.caution_content')}
                    </Typography>
                </Typography>
                <Box
                    component="div"
                    display={'flex'}
                    justifyContent={'center'}
                    gap={'19px'}
                    mt={'39px'}
                >
                    <Button
                        variant="outlined"
                        sx={{
                            width: '155px',
                            height: '60px',
                            borderRadius: '60px',
                            fontWeight: 'bold',
                            fontSize: '20px',
                            lineHeight: '24px',
                            textTransform: 'none',
                            borderWidth: '2px',
                            borderColor: (theme) => theme.palette.primary.main,
                        }}
                        onClick={handleClose}
                    >
                        {t('page.campaign.modal.delete.button_cancel')}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleDelete}
                        sx={{
                            boxShadow: 'none',
                            width: '155px',
                            height: '60px',
                            borderRadius: '60px',
                            fontWeight: 'bold',
                            fontSize: '20px',
                            lineHeight: '24px',
                            textTransform: 'none',
                        }}
                    >
                        {t('page.campaign.modal.delete.button_delete')}
                    </Button>
                </Box>
            </Box>
        </BaseDialog>
    );
};

export default CampaignModalDelete;
